import {Component, Input} from '@angular/core';
import {Vaps} from "../../../../../../domain/vaps/vaps";
import {VapsService} from "../../../../../../domain/vaps/vaps.service";

@Component({
  selector: 'cary-vaps-card',
  templateUrl: './vaps-card.component.html',
  styleUrls: ['./vaps-card.component.scss'],
})
export class VapsCardComponent {
  @Input()
  vaps: Vaps = Vaps.placeholder();

  constructor(private vapsService: VapsService) {
  }

  onClick(): void {
    this.vapsService.toggle(this.vaps).subscribe(() => {
      this.vaps.selected = !this.vaps.selected;
    });
  }
}
